import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ClientPortalLinkedClientAccountModel } from "services/api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  Loading: false,
  LinkedAccounts: undefined as undefined | ClientPortalLinkedClientAccountModel[],
  LastUpdateTime: new Date(),
};

const accountLinkingBannerSlice = createSlice({
  name: "accountLinkingBanner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLinkedClientAccounts.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getLinkedClientAccounts.fulfilled, (state, action) => {
        state.LinkedAccounts = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      })
      .addCase(getLinkedClientAccounts.rejected, (state) => {
        state.LinkedAccounts = undefined;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getLinkedClientAccounts = createAsyncThunk<
  ClientPortalLinkedClientAccountModel[],
  { clientPortalUserID: string; companyID: string }
>("AccountLinkingBanner/GetLinkedClientAccounts", async ({ clientPortalUserID, companyID }) => {
  const usersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  return await usersService.getLinkedClientAccounts(clientPortalUserID, companyID);
});

export const selectLinkedAccounts = (state: RootState) => state.accountLinkingBanner.LinkedAccounts;
export const selectLoadingLinkedAccounts = (state: RootState) => state.accountLinkingBanner.Loading;
export const selectLastUpdateTime = (state: RootState) => state.accountLinkingBanner.LastUpdateTime;

export default accountLinkingBannerSlice.reducer;
